import { createSelector } from 'reselect';
import { getAppConfiguration } from '@mews-commander/data-access';
import moduleSelector from '../selector';
import { DASHBOARD_SHORTCUT } from '../../shortcuts';

export const NAME = 'serverMeta';

const initialState = {};

export default function serverMetaReducer(state = initialState) {
    return state;
}

export const getServerMeta = createSelector(moduleSelector, (state) => state[NAME]);
export const getIdentifier = createSelector(getServerMeta, (state) => state.identifier);
export const getInstanceName = createSelector(getServerMeta, (state) => state.instanceName);
export const getBuildDate = createSelector(getServerMeta, (state) => state.buildDate);

export const getGlobalAdminLogoTitle = createSelector(
    getServerMeta,
    () => getAppConfiguration(),
    (serverState, { platformVersion, version: assetVersion }) =>
        `Server: ${serverState.identifier}\n` +
        `Platform Version: ${platformVersion}\n` +
        `Asset Version: ${assetVersion}\n` +
        `Build: ${serverState.buildDate}\n` +
        `${DASHBOARD_SHORTCUT}`
);
